export const orderProcess = {
    STEPS: {
        NO_ORDER_ONGOING: "no-order-ongoing",
        FILE_UPLOAD: "upload",
        CONFIGURE_MODEL: "configure-model",
        VIEW_CART: "view-cart",
        PROVIDE_CUSTOMER_DETAILS: "provideCustomerDetails",
        REVIEW_ORDER: "review_order",
        ORDER_COMPLETED: "order-completed",
    }
}